import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { IUnderwriterMySuffix } from 'src/app/shared/model/underwriter-my-suffix.model';
import { UnderwriterMySuffixService } from '.';

@Component({
  selector: 'jhi-underwriter-my-suffix-access-dialog',
  templateUrl: './underwriter-my-suffix-access-dialog.component.html',
  styleUrls: []
})
export class UnderwriterMySuffixAccessDialogComponent {
  underwriter: IUnderwriterMySuffix;
  isConfirmed: boolean = false;

  constructor(
    private underwriterService: UnderwriterMySuffixService,
    public activeModal: NgbActiveModal,
    private eventManager: JhiEventManager,
  ) { }

  clear() {
    this.activeModal.dismiss('cancel');
  }

  confirmAction(id: number) {
    this.isConfirmed = true;

    this.underwriterService.accessPlatform(id).subscribe(response => {
      this.eventManager.broadcast({
        name: 'underwriterListModification',
        content: 'Deleted an underwriter'
      });
      this.underwriter.isAccessPlatform = !this.underwriter.isAccessPlatform;
      this.activeModal.dismiss(true);
    });
  }

}


@Component({
  selector: 'jhi-underwriter-my-suffix-access-popup',
  template: ''
})
export class UnderwriterMySuffixAccessPopupComponent implements OnInit, OnDestroy {
  private ngbModalRef: NgbModalRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private languageChangeService: LanguageChangeService
  ) { 
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe(({ underwriter }) => {
      setTimeout(() => {
        this.ngbModalRef = this.modalService.open(UnderwriterMySuffixAccessDialogComponent as Component, {
          size: 'lg',
          backdrop: 'static'
        });
        this.ngbModalRef.componentInstance.underwriter = underwriter;
        this.ngbModalRef.result.then(
          result => {
            //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
            this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/underwriter']));
            this.ngbModalRef = null;
          },
          reason => {
            //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
            this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/underwriter']));
            this.ngbModalRef = null;
          }
        );
      }, 0);
    });

    
    this.languageChangeService.currentLanguage.subscribe(language => {
      console.log(language);
    });
  }

  ngOnDestroy() {
    this.ngbModalRef = null;
  }
}
